import { getHeaderElement } from './get-header-element';

export const isHeaderTransparent = (): boolean => {
  const headerElement: HTMLElement = getHeaderElement();
  return headerElement.classList.contains('header--transparent');
};
